import { SimpleFormComponentProps, FormValuesType, SimpleFormAreaState, FormOptions } from 'app/infrastructure/simple-form/types';
import { ValidationProps } from 'ui';
import {
  OperationEndpoints, PersonOptionsCodes, Person, AccessItem, User, AccessPanelData
} from 'app/components/access-panel/shared/types';
import { OptionsProps } from 'app/components/options-handler';

export type UpdateAccessDataAction = (key: string, accessItem: Partial<AccessItem>) => void;
export type ClearValidationAction = (formName: string, parameters?: { [key: string]: number | string }) => void;

export interface PanelsProps<Data = User | Person> extends OptionsProps {
  roleSelected: boolean;
  roleBasedData: Data;
  data: Data;
  fetchingRoleBasedData: boolean;
  readOnly: boolean;
  formComponent: React.ComponentType<SimpleFormComponentProps>;
  formValues: FormValuesType;
  endpoints: OperationEndpoints;
  validation: { [key: string]: ValidationProps };
  personOptionsCodes?: PersonOptionsCodes;
  translation: any;
  accessData: AccessPanelData;
  levelsNotAllowed?: { accessToScreen?: boolean; };
  displaySelectAll?: boolean;
  updateAccessData: UpdateAccessDataAction;
  clearValidation: ClearValidationAction;
  clearValueInStore: (id: string) => void;
  simpleForm?: SimpleFormAreaState;
  formOptions?: FormOptions;
}

export enum GroupingType {
  Single,
  Multiple
}
